import { createSelector } from 'reselect';
import { filter, forEach, keyBy, map } from 'es-toolkit/compat';

import * as TableBasedTemplates from 'types/tableBasedTemplates';
import { StoreType } from '@tock/shared/utils/connect';
import { core } from '@tock/coretypes';
import { getColorOfTicketTypeId } from 'utils/templateUtils';
import { getDefaultPrice } from 'utils/experienceUtils';
import { getDisplayColorValueFromTicketType } from 'utils/customExperienceColorsUtils';
import {
  isTicketTypeEventVariety,
  isTicketTypeTablesideVariety,
} from '@tock/shared/utils/offerings';
import activeTemplateInfosSelector from 'selectors/routes/table-based-templates/activeTemplateInfosSelector';

export default createSelector(
  (state: StoreType) => state.templateInfo.allActiveTickets,
  (state: StoreType) => state.templateInfo.tickets,
  activeTemplateInfosSelector,
  (
    allActiveTickets: core.TicketType[],
    tickets: core.TicketType[],
    activeTemplateInfos
  ): TableBasedTemplates.TicketTypeInfoMap => {
    const experienceToCoverCount: { [id: number]: number } = {};
    forEach(activeTemplateInfos, (templateInfo) => {
      if (!templateInfo.ticketTypeId) {
        return;
      }
      experienceToCoverCount[templateInfo.ticketTypeId] =
        (experienceToCoverCount[templateInfo.ticketTypeId] || 0) + templateInfo.maxSize;
    });

    return keyBy(
      map(
        filter(
          tickets,
          (ticketType) =>
            !isTicketTypeEventVariety(ticketType) && !isTicketTypeTablesideVariety(ticketType)
        ),
        (ticketType): TableBasedTemplates.TicketTypeSlimInfo => {
          return {
            id: ticketType.id,
            colorClassName: getColorOfTicketTypeId(allActiveTickets, ticketType.id),
            covers: experienceToCoverCount[ticketType.id] || 0,
            defaultPrice: getDefaultPrice(ticketType),
            ticketTypePriceConfig: ticketType.ticketTypePriceConfig,
            displayColor: getDisplayColorValueFromTicketType(ticketType),
            fees: ticketType.fee as core.TicketTypeFee[],
            isArchived: ticketType.isArchived,
            name: ticketType.name,
            shortCode: ticketType.shortCode,
            supplementGroups: ticketType.optionGroup as core.TicketOptionGroup[],
            variety: ticketType.variety,
          };
        }
      ),
      'id'
    );
  }
);
